import { css } from '@emotion/react';
import { Colors } from '../common/Colors';

export const helperShowScrollOnParentHover = css`
  html & {
    scrollbar-color: transparent transparent; // стилизует скроллбары ff
    transition: scrollbar-color 0.3s;

    ::-webkit-scrollbar-thumb {
      background-color: transparent; // стилизует скроллбары chrome
    }

    &:hover,
    &:focus {
      scrollbar-color: ${Colors.scroll.normal} transparent;

      ::-webkit-scrollbar-thumb {
        background-color: ${Colors.scroll.normal};
      }
    }
  }
`;
